import { css, Theme } from '@emotion/react'
import { Box, Typography } from '@mui/material'

const PrivacyPolicy = () => {
  return (
    <Box css={styles.container} component='section' id='policy'>
      <Box component='article'>
        <Typography color='primary' variant='h1' css={styles.title}>
          PRIVACY POLICY
        </Typography>
        <Typography color='primary' variant='h2' css={styles.subtitle}>
          個人情報保護方針
        </Typography>
      </Box>
      <Box component='article' css={styles.text}>
        <Typography
          color='primary'
          variant='body1'
          component='aside'
          css={styles.history}>
          2021年5月13日制定（初版）
        </Typography>
        <Typography
          color='primary'
          variant='body1'
          component='p'
          css={styles.head}>
          オフィスエデュアド
          <br />
          <br />
          オフィスエデュアドは、本ウェブサイト上で提供するサービスにおけるプライバシー情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。また、当オフィスは、EU圏内の個人または法人に対しサービスを提供していません。
        </Typography>
        <ul css={styles.list}>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>1. プライバシー情報の定義</h3>
            <p>
              プライバシー情報とは、氏名、生年月日、住所、電話番号、連絡先等、特定の個人を識別できる情報を指します。またそれ以外の、ご利用いただいたサービス、ご覧になったページや広告の履歴、ユーザーが検索された検索キーワード、ご利用日時、ご利用の方法、ご利用環境、郵便番号や性別、職業、年齢、ユーザーのIPアドレス、Cookie情報、位置情報、端末の個体識別情報などを指します。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>2. プライバシー情報の収集方法</h3>
            <p>
              当オフィスは、ユーザーが問い合わせや利用登録をする際に、氏名、生年月日、住所、電話番号、メールアドレス、銀行口座番号、クレジットカード番号、などのプライバシー情報をお尋ねすることがあります。また当オフィスは、ユーザーについて、利用したサービスや閲覧したページや広告の履歴、検索した検索キーワード、利用日時、利用方法、利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態、利用に際しての各種設定情報なども含みます）、IPアドレス、Cookie情報、位置情報、端末のプライバシー識別情報などの情報を収集します。
              <br />
              <br />
              当オフィスは、他の事業者から委託された業務（他の事業者の広告運用等）の実施のため、他の事業者が取得したプライバシー情報を取得する場合があります。この場合、委託された当該業務の実施に必要となる範囲でのみ、当該プライバシー情報を利用します。
              <br />
              <br />
              当オフィスは、以下の目的のため、その範囲内においてのみ、プライバシー情報を収集・利用いたします。当サイトによるプライバシー情報の収集・利用は、ユーザーの自発的な提供によるものであり、ユーザーがプライバシー情報を提供された場合は、当サイトが本方針に則ってプライバシー情報を利用することをユーザーが許諾したものとします。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>
              3. プライバシー情報を収集・利用する目的
            </h3>
            <p>
              当オフィスがプライバシー情報を収集、利用する目的は、以下のとおりです。
              <br />
              ・資料を送付するため
              <br />
              ・お問い合わせの確認、その回答の連絡に利用するため
              <br />
              ・情報提供などのサービス提供のため
              <br />
              ・その他ご案内を送付するため
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>4. プライバシー情報の管理</h3>
            <p>
              当オフィスは、法令に基づく場合等正当な理由によらない限り、事前に本人の同意を得ることなく、プライバシー情報を第三者に開示・提供することはありません。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>5. プライバシー情報の第三者提供</h3>
            <p>
              当オフィスは、お客様へ商品やサービスを提供する等の業務遂行上、プライバシー情報の一部を外部の委託先へ提供する場合があります。その場合、業務委託先が適切にプライバシー情報を取り扱うように管理いたします。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>
              6. プライバシー情報の照会・修正・削除
            </h3>
            <p>
              当オフィスは、お客様が当サイトにご提供いただいたプライバシー情報の照会、修正または削除を希望される場合は、ご本人であることを確認させていただいたうえで、合理的な範囲ですみやかに対応させていただきます。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>7. Cookie情報について</h3>
            <p>
              Cookie情報について、ユーザーのプライバシーの保護、利便性の向上、広告の配信および統計データの取得のために使用します。ユーザーは、インターネット閲覧ソフトの設定でCookieの受取りを拒否することにより、弊社によるCookieの利用を拒否することができます。当オフィスは、サービスの利用状況の把握および分析にGoogle
              Analyticsを利用しています。Google
              AnalyticsはCookieを利用して動作をしており、Google社に
              よるアクセス情報の収集方法および利用方法については、Google
              Analyticsサービス利用規約およびGoogle社プライバシーポリシーによって定められています。Google
              Analyticsを無効化したい場合はGoogle
              Analyticsオプトアウトアドオンをインストールし、ブラウザのアドオン設定を変更してください。また、Cookieを利用した広告の配信を無効にしたい場合は、広告媒体のオプトアウトページにアクセスし、手順に従ってください。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>8. プライバシーポリシーの変更</h3>
            <p>
              本ポリシーの内容は、ユーザーに通知することなく、変更することができるものとします。また変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>
          </li>
          <li css={styles.listItem}>
            <h3 css={styles.listTitle}>9. お問い合わせについて</h3>
            <p>
              本ポリシーに関するお問い合わせは、下記までお願いいたします。
              <br />
              ・オフィスエデュアド
              <br />
              ・info@edu-ad.com
              <br />
              ・神奈川県相模原市中央区淵野辺2丁目5番62号
            </p>
          </li>
        </ul>
      </Box>
    </Box>
  )
}

const styles = {
  container: css`
    width: 80vw;
    max-width: 1100px;
    margin: 0 auto;
    @media (max-width: 768px) {
      width: 90vw;
    }
  `,
  title: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 1rem;
    @media (max-width: 768px) {
      font-size: 3rem;
      margin-bottom: 0.2rem;
    }
  `,
  subtitle: css`
    line-height: 3rem;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 3rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
  `,
  text: css`
    * {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 1rem;
      font-weight: 500;
      line-height: 2rem;
    }
  `,
  history: css`
    margin-bottom: 2rem;
    text-align: right;
    @media (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.5rem;
      margin-bottom: 1rem;
    }
  `,
  head: css`
    margin-bottom: 60px;
  `,
  list: css`
    list-style: none;
    padding-inline-start: 0;
  `,
  listItem: (theme: Theme) => css`
    margin-bottom: 60px;
    & * {
      color: ${theme.palette.primary.main};
    }
    & p {
      @media (max-width: 768px) {
        font-size: 0.8rem;
        padding: 0 10px;
      }
    }
  `,
  listTitle: css`
    font-size: 1.4rem;
  `,
}

export default PrivacyPolicy
